const initialState = {
  total: 0
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_TOTALES':
      return {
        ...state,
        total: action.data
      }
    default:
      return state
  }
}
